import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Product, ProductScope, TranslationService } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { combineLatest, Observable, of, Subscription, take } from 'rxjs';
import { ModalService } from '../../../../components/modal-list/modal-list.service';
import { ProductInventoryComponent } from '../product-inventory/product-inventory.component';
import { Warehouse } from '../product-inventory/core/product-inventory.model';
import { ProductCheckInventoryService } from '../product-inventory/product-check-inventory.service';

@Component({
  selector: 'check-inventory',
  templateUrl: './check-inventory.component.html',
  styleUrl: './check-inventory.component.scss',
  standalone: false,
})
export class CheckInventoryComponent implements OnInit, OnDestroy {
  @HostBinding('class') hostClass = '';
  @Input() InProduct$?: Observable<Product>;
  @Input() hasRadio?: boolean = true;
  @Input() currentWarehouse?: Warehouse;
  @Input() readonly: boolean = false;
  @Input() requestShippingDate: string = '';
  @Output() _onSelectWarehouse = new EventEmitter();

  product$: Observable<Product | null> = this.currentProductService.getProduct([
    ProductScope.DETAILS,
    ProductScope.PRICE,
  ]);

  subscription = new Subscription();

  constructor(
    protected currentProductService: CurrentProductService,
    private modalService: ModalService,
    private translationService: TranslationService,
    private cdr: ChangeDetectorRef,
    private productCheckInventoryService: ProductCheckInventoryService,
  ) {}

  ngOnInit(): void {
    this.checkInputs();
    this.checkProduct();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkInputs() {
    this.subscription.add(
      this.InProduct$?.subscribe(product => {
        this.product$ = of(product);
      }),
    );
  }

  checkProduct() {
    this.subscription.add(
      this.product$.subscribe(product => {
        this.hostClass = product?.discontinued ? 'd-none product-discontinued' : '';
      }),
    );
  }

  openModal() {
    combineLatest([this.product$, this.translationService.translate('inventory.modal.title')])
      .pipe(take(1))
      .subscribe(([product, modalTitle]: any) => {
        this.modalService.create({
          id: 'modal-check-inventory',
          title: modalTitle,
          width: 900,
          component: ProductInventoryComponent,
          classList: 'modal-check-inventory',
          data: {
            product,
            hasRadioOptions: this.hasRadio,
            currentWarehouse: this.currentWarehouse,
            requestShippingDate: this.requestShippingDate,
            selectWarehouse: (warehouse: Warehouse) => {
              this.currentWarehouse = warehouse;

              this.productCheckInventoryService.setWarehouseProduct({
                productID: product.code!,
                warehouseID: warehouse.warehouseCode!,
              });

              this._onSelectWarehouse.emit(warehouse);
              this.cdr.detectChanges();
            },
          },
        });
      });
  }
}
